import api from '../../services/api';

export interface IFeatureFlag {
  id: number;
  feature_name: string;
  enabled: boolean;
}

export const getFeatureFlags = (): Promise<{ feature_flags: IFeatureFlag[] }> => api.get('/api/frontend/feature_flags');
